import { getModule } from "vuex-module-decorators";
import AuthStore from "./modules/auth.store";
import NotifStore from "./modules/notif.store";
import store from "./store";

export const Auth = getModule(AuthStore, store);

export const Notif = getModule(NotifStore, store);
